var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderHomeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "folder-home-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.855,
    height: 26.233,
    viewBox: "0 0 33.855 26.233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M33.855,6.568V23.432a3.021,3.021,0,0,1-3.183,2.8H3.183A3.021,3.021,0,0,1,0,23.432V2.82A3.018,3.018,0,0,1,3.183,0h10.68l4.272,3.785H30.822a3,3,0,0,1,3.033,2.782Z",
    transform: "translate(0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M15.374,9.548a.614.614,0,0,1-.629.6h-.629v3.741a.629.629,0,0,1-.614.614H11.633a.614.614,0,0,1-.614-.614v-2.17a.3.3,0,0,0-.3-.3H8.849a.314.314,0,0,0-.314.3V13.9a.614.614,0,0,1-.614.614H6.051a.629.629,0,0,1-.644-.614V10.162h-.6A.625.625,0,0,1,4.39,9.07L9.358,4.73a.673.673,0,0,1,.4-.15.644.644,0,0,1,.4.15l4.968,4.34A.569.569,0,0,1,15.374,9.548Z",
    transform: "translate(7.137 5.758)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderHomeIcon);
export default __webpack_public_path__ + "static/media/folder-home-icon.28cbaec008a4f93acdb3ec1fb105dc29.svg";
export { ForwardRef as ReactComponent };